<style lang="less" scoped>
    .h5-charge-card-list-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #ffffff;

        .header-title-div {
            height: 32px;
            display: flex;
            margin-top: 16px;

            .header-left-img-div {
                width: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
            }

            .header-title {
                flex: 1;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 32px;
            }

            .header-right-get-title {
                flex: 1;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #04B6B6;
                line-height: 32px;
                margin-right: 12px;
                text-align: right;
            }
        }

        .charge-card-list-div {
            flex: 1;
            overflow-y: auto;
            margin: 16px 12px 0 12px;

            .charge-card-child-div {
                height: 173px;
                width: 100%;
                border-radius: 30px;
                margin-bottom: 12px;
                background-size: 100% 100%;
                display: flex;

                .card-logo-div {
                    margin-left: 36px;
                    margin-top: 24px;
                    width: 47px;
                    height: 47px;
                    border-radius: 50%;
                    background-color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .right-card-info-div {
                    display: flex;
                    flex-direction: column;
                    flex: 1;

                    .card-title-div {
                        margin-top: 24px;
                        margin-right: 32px;
                        text-align: right;
                        height: 20px;
                        font-size: 14px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                        line-height: 20px;
                    }

                    .card-contact-div {
                        height: 14px;
                        font-size: 10px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 14px;
                        margin-right: 32px;
                        text-align: right;
                    }

                    .card-degree-div {
                        height: 17px;
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        text-align: right;
                        margin-right: 32px;
                        line-height: 17px;
                        margin-bottom: 32px;
                    }

                    .card-degree-value-div {
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }
                }
            }
        }

        .charge-card-tips-info-div {
            margin: 12px 16px;
            font-size: 12px;
            color: #444;
        }

        .charge-card-list-div::-webkit-scrollbar {
            display: none;
        }

        .bold-dealer-span {
            display: inline-block;
            color: #00b5b7;
        }

        .no-card-img-div {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .no-card-tips-main {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 32px;
                margin-top: 32px;
            }

            .no-card-tips-sub {
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
            }
        }
    }
</style>

<template>
    <div class="h5-charge-card-list-container">
        <div class="header-title-div">
            <div class="header-left-img-div" @click="backToAppFun()">
                <img class="header-back-img" src="../../assets/h5-img/back.png" width="18" />
            </div>
            <div class="header-title">我的充电卡</div>

            <div class="header-right-get-title" @click="toExchangeCardPage">兑换</div>
        </div>
        <div class="charge-card-list-div">
            <div class="charge-card-child-div" v-for="card in cardList" :key="card.cardId" @click="toCardDetail(card)" :style="`background-image: url('${card.chargeCardBackground}');`">
                <div class="card-logo-div">
                    <img :src="card.iconImg" width="29" height="30">
                </div>
                <div class="right-card-info-div">
                    <div class="card-title-div">{{card.dealerName}}·充电卡</div>
                    <div class="card-contact-div">服务电话：{{card.connectPhone}}</div>
                    <div class="flex-1"></div>
                    <div class="card-degree-div">
                        剩余度数:
                        <span class="card-degree-value-div">{{card.cardElectricBalance}}</span> 度
                    </div>
                </div>
            </div>

            <div class="no-card-img-div" v-show="cardList.length<=0">
                <img src="../../assets/h5-img/no-card.png" width="154" height="92">
                <div class="no-card-tips-main">没有符合条件的充电卡</div>
                <div class="no-card-tips-sub">可联系运营商开通</div>
            </div>
        </div>
        <div class="charge-card-tips-info-div">
            <div class="ccti-child-div">服务商抵扣额度</div>
            <div class="ccti-child-div">使用范围：仅限服务商充电桩</div>
            <div class="ccti-child-div">获得方式：通过联系服务商，获取专属额度</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isAndroid: false,
                isIos: false,
                curUserPhone: '',
                curUserLon: '',
                curUserLat: '',
                cardList: [],
            }
        },
        methods: {
            init() {
                let _ = this;
                _.$U.showLoading(_);
                var u = navigator.userAgent;
                this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
                this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
                if (this.isAndroid) {
                    _.$store.commit('setToken', jsBridge.getToken());
                    _.curUserPhone = jsBridge.getUserPhone();
                    _.curUserLon = jsBridge.getUserLon();
                    _.curUserLat = jsBridge.getUserLat();
                }
                if (this.isIos) {
                    window['getUserPhone'] = function(res) {
                        const resData = res.split(',');
                        _.curUserPhone = resData[1];
                        _.$store.commit('setToken', resData[0])
                        _.curUserLon = resData[2];
                        _.curUserLat = resData[3];
                    };
                    // window['getToken'] = function(res) {
                    //     alert(res);
                    //     _.$store.commit('setToken', res);
                    // };

                    // window['getUserLon'] = function(res) {
                    //     _.curUserLon = res;
                    // };
                    // window['getUserLat'] = function(res) {
                    //     _.curUserLat = res;
                    // }
                }
                setTimeout(function() {
                    _.$store.commit('setCurAppH5Info', {
                        curUserPhone: _.curUserPhone,
                        curUserLon: _.curUserLon,
                        curUserLat: _.curUserLat,
                    });
                    _.getUserCards();
                }, 500)
            },
            getUserCards() {
                let _ = this;
                const querInfo = {
                    corpNo: _.$C.corpNo,
                    userPhone: _.curUserPhone,
                    pageNum: 0,
                    pageSize: 999
                };
                _.$U.showLoading(_);
                _.$H.post(_, _.$A.h5.chargeCards, querInfo).then(res => {
                    _.cardList = res.data.data.content;
                    _.$U.hideLoading();
                })
            },
            toCardDetail(cardInfo) {
                this.$store.commit('setCurSelChargeCardInfo', cardInfo);
                this.$router.push({
                    name: 'h5_chargeCardDetail'
                })
            },
            // 返回APP事件
            backToAppFun() {
                var u = navigator.userAgent;
                this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
                this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
                if (this.isAndroid) {
                    jsBridge && jsBridge.backToApp();
                    window.android.jsBridge.backToApp();
                }
                if (this.isIos) {
                    window.webkit.messageHandlers.backToApp.postMessage(null);
                }
            },
            toExchangeCardPage() {
                this.$router.push({
                    name: 'h5_cardExchange'
                })
            },
        },
        mounted() {
            // this.curUserPhone = '15896465276';
            // this.getUserCards();
            if (this.$store.state.cardDetailBack == 'Y') {
                this.$store.commit('setCardDetailBack', 'N')
                const info = this.$store.state.curAppH5Info || {};
                this.curUserPhone = info.curUserPhone;
                this.getUserCards();
            } else {
                this.init();
            }
        }
    }
</script>